// extracted by mini-css-extract-plugin
export default {"backToTopBtn":"BackToTopButton_backToTopBtn__zcct2","appear":"BackToTopButton_appear__UIOPm","arrow":"BackToTopButton_arrow__4Ar0m"};